import { render, staticRenderFns } from "./VincularDoc.vue?vue&type=template&id=5c11a1b2&scoped=true&lang=pug&"
import script from "./VincularDoc.vue?vue&type=script&lang=js&"
export * from "./VincularDoc.vue?vue&type=script&lang=js&"
import style0 from "./VincularDoc.vue?vue&type=style&index=0&id=5c11a1b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c11a1b2",
  null
  
)

export default component.exports